import React, {useState} from 'react';
import {
    teeth,
    canBridge,
    getFirstAndLastTeethInBridge
} from "../common/teeth"


const Pop = (props)=> {

    const {
        popType,
        popClicked,
        tooth,
        activeTeeth,
        teethState,
        getPositionsWithoutBridges
    } = props;

    const isToothInTop = ()=>{
        return teeth.top.find(item=>item===tooth) !== undefined
    }

    const getIndicatorClass = ()=>{
        const position = isToothInTop()? "top" : "bottom";
        const toothIndex = teeth[position].findIndex(item=>item === tooth);
        if(toothIndex < 4){
            return `ind-end-${toothIndex+1}-left`;
        }else if(toothIndex > 11){
            return `ind-end-${16-toothIndex}-right`;
        }else return "";
    }

    const getPopContent = (popType)=>{
        let positionsWithoutBridges;
        switch (popType) {
            case "partial-range":
                return(
                    <>
                        <div className='top'>
                            <p>{abraStr.addRange}</p>
                        </div>
                        <a
                            onClick={()=>{
                                popClicked(0,"choose-implants")
                            }}
                        >{abraStr.chooseImplants}</a>
                    </>
                );
            case "telescopic-cap":
                return (
                    <>
                        <p>{abraStr.telescopicCapMaterial}</p>
                        <div className='pop-items-container'>

                            <div
                                className='pop-content-text'
                                onClick={()=>{popClicked(tooth,"gold")}}
                            >
                                {abraStr.gold}
                            </div>
                            <div
                                className='pop-content-text highlight'
                                onClick={()=>{popClicked(tooth,"non-precious")}}
                            >
                                {abraStr.nonPrecious}
                            </div>
                        </div>
                    </>
                );
            case "add-or-complete":
                return(
                    <div className='pop-items-container'>
                        <div
                            className='pop-content-text'
                            onClick={()=>{popClicked(tooth,"add-more-teeth")}}
                        >
                            {abraStr.addMoreTeeth}
                        </div>
                        <div
                            className='pop-content-text highlight'
                            onClick={()=>{popClicked(tooth,"complete-bridge")}}
                        >
                            {abraStr.complete}
                        </div>
                    </div>
                );
            case "complete":
                return(
                    <>
                        <div className='top'>
                            <p>{abraStr.completePartialBridge}</p>
                        </div>
                        <div className='pop-items-container'>

                            <a
                                onClick={()=>{popClicked(0,"complete-bridge")}}
                            >
                                {abraStr.complete}
                            </a>
                        </div>
                    </>
                );

            case "add-only":
                const [first,second] = getFirstAndLastTeethInBridge(activeTeeth);
                const [firstNumerical,secondNumerical] = [first,second].sort();
                const addRangeIsLegit = [first,second].includes(tooth);
                return(
                    <div className='pop-items-container'>
                        <div
                            className='pop-content-text'
                            onClick={()=>{popClicked(tooth,"add-single")}}
                        >
                            {`${abraStr.add} ${abraStr.only} ${tooth}${abraStr.th} ${abraStr.tooth}`}
                        </div>
                        <div
                            className={`pop-content-text`}
                            onClick={()=>{popClicked(tooth,"add-all")}}
                        >
                            {`${abraStr.add} ${firstNumerical}-${secondNumerical} ${abraStr.teeth}`}
                        </div>
                    </div>
                );

            case "telescopic": case "bridge": case "overdenture":
                return(
                    <div className='pop-items-container'>
                        { ["bridge","overdenture"].includes(popType)  &&
                        <div
                            className='pop-content-abutment'
                            onClick={()=>{popClicked(tooth,"abutment")}}
                        >
                            {abraStr.abutmentTooth}
                        </div>
                        }
                        <div
                            className='pop-content-implant'
                            onClick={()=>{popClicked(tooth,"implant")}}
                        >
                            {abraStr.addImplant}
                        </div>
                        {popType === "bridge" &&
                        <div
                            className='pop-pontic'
                            onClick={()=>{popClicked(tooth,"crown")}}
                        >
                            {abraStr.pontic}
                        </div>
                        }
                        {
                            ["telescopic","bridge"].includes(popType)  &&
                            <div
                                className='pop-no-tooth'
                                onClick={()=>{popClicked(tooth,"no-tooth")}}
                            >
                                {abraStr.noTooth}
                            </div>
                        }

                    </div>
                );

                case "overdenture-type":
                     positionsWithoutBridges = getPositionsWithoutBridges();
                    return(
                        <div className='pop-items-container'>
                            <div
                                className={`pop-whole ${!positionsWithoutBridges && "disabled"}`}
                                onClick={()=>{positionsWithoutBridges && popClicked("whole")}}
                            >
                                {abraStr.whole}
                            </div>
                            <div
                                className='pop-partial'
                                onClick={()=>{popClicked("partial")}}
                            >
                                {abraStr.partial}
                            </div>
                        </div>
                    );

            case "jaw-type":
                positionsWithoutBridges = getPositionsWithoutBridges();
                return (
                    <>
                        <p>{abraStr.selectJaw}</p>
                        <div className='pop-items-container'>

                            <div
                                className={`pop-both ${positionsWithoutBridges !== "all"? "disabled" : ""}`}
                                onClick={()=>{positionsWithoutBridges === "all" && popClicked(0,"both")}}
                            >
                                {abraStr.both}
                            </div>
                            <div
                                className={`pop-upper ${!["all","top"].includes(positionsWithoutBridges)? "disabled" : ""}`}
                                onClick={()=>{["all","top"].includes(positionsWithoutBridges) && popClicked(0,"top")}}
                            >
                                {abraStr.upper}
                            </div>
                            <div
                                className={`pop-upper ${!["all","bottom"].includes(positionsWithoutBridges)? "disabled" : ""}`}
                                onClick={()=>{["all","bottom"].includes(positionsWithoutBridges) && popClicked(0,"bottom")}}
                            >
                                {abraStr.lower}
                            </div>
                        </div>
                    </>
                )
            case "select-teeth":
                const  hasActiveTeeth =  activeTeeth.length
                return (
                    <>
                        <div className='top'>
                            <span/>
                            <p className='warning'>{abraStr.selectTeethInOverDenture}</p>
                        </div>
                        <a
                        className={hasActiveTeeth? "" : "disabled"}
                        onClick={()=>{
                            hasActiveTeeth && popClicked(0,"complete")
                        }}
                        >{abraStr.complete}</a>
                    </>
                )
        }
    }

    return(
      <div className={`abra-pop type-${popType} ${getIndicatorClass()}`}>
          {getPopContent(popType)}
      </div>
    );
}


export default Pop;

